// Embedded Manuals for Torre de Control
// Using Vite's ?raw import from src/assets to ensure compatibility

import manualUsuario from '../assets/manuals/MANUAL_USUARIO.md?raw'
import manualTecnico from '../assets/manuals/MANUAL_TECNICO_AGENTE.md?raw'
import manualIA from '../assets/manuals/MANUAL_COMANDOS_IA.md?raw'
import instruccionesKit from '../assets/manuals/INSTRUCCIONES_KIT.md?raw'

export const manuals = [
    {
        id: 'usuario',
        title: 'Manual de Usuario',
        icon: 'Book',
        content: manualUsuario
    },
    {
        id: 'tecnico',
        title: 'Manual Técnico de Integración (Agente)',
        icon: 'Code',
        content: manualTecnico
    },
    {
        id: 'ia_ops',
        title: 'Manual de Operaciones IA (Comandos)',
        icon: 'Bot',
        content: manualIA
    },
    {
        id: 'kit',
        title: 'Kit de Integración (Instrucciones)',
        icon: 'Package',
        content: instruccionesKit
    }
];
